module.exports = __webpack_public_path__ + "assets/img/00059.8717061d.png";